import { ChangeDetectionStrategy, Component, Directive, Input, ViewEncapsulation } from '@angular/core';

// noinspection TsLint
@Component({
  selector: 'dva-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  host: { class: 'dva-card' },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Card {}

// noinspection TsLint
@Component({
  selector: 'dva-card-header',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'dva-card-header' },
  template: `
    <div class="dva-card-header-heading-group">
      <ng-content select="dva-card-header-heading"></ng-content>
      <ng-content select="dva-card-header-subheading"></ng-content>
    </div>
    <ng-content></ng-content>
    <ng-content select="dva-card-header-actions"></ng-content>
  `,
})
export class CardHeader {}

// noinspection TsLint
@Component({
  selector: 'dva-card-content',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'dva-card-content' },
  template: ` <ng-content></ng-content>`,
})
export class CardContent {}

// noinspection TsLint
@Directive({
  selector: 'dva-card-header-heading',
  host: { class: 'dva-card-header-heading' },
})
export class CardHeaderTitle {}

// noinspection TsLint
@Directive({
  selector: 'dva-card-header-subheading',
  host: { class: 'dva-card-header-subheading' },
})
export class CardHeaderSubTitle {}

// noinspection TsLint
@Directive({
  selector: 'dva-card-header-actions',
  host: { class: 'dva-card-header-actions' },
})
export class CardHeaderActions {}

// noinspection TsLint
@Directive({
  selector: 'dva-card-actions',
  host: {
    class: 'dva-card-actions',
    '[class.dva-card-actions-align-end]': 'align === "end"',
  },
})
export class CardActions {
  /** Position of the actions inside the card. */
  @Input() align: 'start' | 'end' = 'start';
}
